import {login, logout, getInfo} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'

const user= {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
  },
  actions: {
    // 用户登录的方法
    login({commit}, userInfo) {
      const {username, password} = userInfo;

      return new Promise((resolve, reject) => {
        login({username: username.trim(), password: password}).then(response => {
          const {data} = response
          commit('SET_TOKEN', data.nonceToken)
          sessionStorage.setItem("username", data.username);
          let userRole = [];
          // 根据权限控制按钮
          for (let i = 0; i < data.roles.length; i++) {
            userRole.push(data.roles[i].role)
          }
          commit('SET_ROLES', userRole)
          setToken(data.nonceToken)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // get user info
    getInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const {data} = response
          if (!data) {
            reject('Verification failed, please Login again.')
          }
          const {name, avatar} = data
          commit('SET_NAME', name)
          commit('SET_AVATAR', avatar)
          let userRole = [];
          // 根据权限控制按钮
          for (let i = 0; i < data.roles.length; i++) {
            userRole.push(data.roles[i].role)
          }
          commit('SET_ROLES', userRole)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // user logout
    logout({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          // resetRouter()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // remove token
    resetToken({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}
export default  user




// WEBPACK FOOTER //
// ./src/store/modules/user.js